/* eslint-disable @next/next/no-img-element */
import { ElementProps } from '@/components/sections/builder/types';
import { HeroElementDataType } from '@/components/sections/builder/elements/body/hero/types';
import { WrapperChild } from '@/components/sections/builder/wrapper';
import clsx from 'clsx';
import Link from 'next/link';
import useMediaQuery from '@/hooks/useMediaQuery';
import { hexToRgb } from '@/lib/utils';

export default function ElementContent({ element, preview }: ElementProps) {
  const childs = element.childs;
  const data = element.data as HeroElementDataType;
  const imgUrl = useMediaQuery(data.mobileMinWidth) && data.mobileImg ? data.mobileImg : data.image;

  return (
    <>
      <section
        className={clsx(
          'background-color-default',
          data.background?.type === 'color' && 'background-color',
          data.background?.type === 'image' && 'background-image',
          data?.layout === 'full' && 'hero-full-width'
        )}
      >
        <div
          className={clsx(
            ' duration-100',
            data.layout !== 'full' && 'theme_layout_page_width mx-auto'
          )}
        >
          <div className={clsx('hero-padding relative')}>
            {data.overlay && data.background?.type !== 'image' && (
              <div className={clsx('overlay absolute inset-0')} />
            )}
            <div
              className={clsx(
                'relative mx-auto flex w-full gap-8 text-wrap bg-opacity-0 @xl:gap-0 lg:flex lg:gap-8 lg:py-16',
                data.imagePosition === 'left' && 'flex-row-reverse',
                data.imagePosition === 'top' && 'flex-col-reverse pb-8 lg:pb-16 lg:pt-0',
                data.imagePosition === 'bottom' && 'flex-col pt-8 lg:pb-0 lg:pt-16',
                data.contentAlign === 'left' && 'items-start',
                data.contentAlign === 'center' && 'items-center',
                data.contentAlign === 'right' && 'items-end',
                data.layout !== 'full' && 'max-w-screen-xl'
              )}
            >
              <div
                className={clsx(
                  'flex flex-col break-words px-4 text-center',
                  data.contentAlign === 'left' && 'items-start text-left [&>button>*]:text-left',
                  data.contentAlign === 'center' &&
                    'items-center text-center [&>button>*]:text-center',
                  data.contentAlign === 'right' && 'items-end text-right [&>button>*]:text-right',
                  imgUrl ? 'lg:w-7/12' : 'w-full'
                )}
              >
                {(childs || []).map((child) => (
                  <WrapperChild
                    child={{ ...child, parentData: data }}
                    parentType={element.type}
                    key={child.id}
                    preview={preview}
                  />
                ))}
              </div>
              {/* {imgUrl &&
                (['top', 'bottom'].includes(data.imagePosition ?? '') ? (
                  <Link href={`/${data.imageUrl || '#'}`} className='w-full'>
                    <div
                      className={clsx(
                        'flex items-center justify-center overflow-hidden lg:mt-0',
                        data.imagePosition === 'top' || data.imagePosition === 'bottom'
                          ? 'w-full px-0 lg:w-full'
                          : 'px-4 lg:w-5/12'
                      )}
                      data-animation='true'
                    >
                      <img
                        src={imgUrl}
                        alt='mockup'
                        className={clsx(
                          'w-full object-cover',
                          !['top', 'bottom'].includes(data.imagePosition as string) &&
                            'max-h-[290px]',
                          ['top', 'bottom'].includes(data.imagePosition as string) &&
                            data?.imageHeight === 'adapt' &&
                            'h-full',
                          ['top', 'bottom'].includes(data.imagePosition as string) &&
                            data?.imageHeight === 'small' &&
                            'h-[280px] md:h-[420px]',
                          ['top', 'bottom'].includes(data.imagePosition as string) &&
                            data?.imageHeight === 'medium' &&
                            'h-[340px] md:h-[560px]',
                          ['top', 'bottom'].includes(data.imagePosition as string) &&
                            data?.imageHeight === 'large' &&
                            'h-[720px] md:h-[790px]'
                        )}
                      />
                    </div>
                  </Link>
                ) : (
                  <div
                    className={clsx(
                      'flex items-center justify-center overflow-hidden lg:mt-0',
                      data.imagePosition === 'top' || data.imagePosition === 'bottom'
                        ? 'w-full px-0 lg:w-full'
                        : ' px-4 lg:w-5/12'
                    )}
                    data-animation='true'
                  >
                    <Link href={`/${data.imageUrl || '#'}`}>
                      <img
                        src={imgUrl}
                        alt='mockup'
                        className={clsx(
                          'w-full object-cover',
                          !['top', 'bottom'].includes(data.imagePosition as string) &&
                            'max-h-[290px]',
                          ['top', 'bottom'].includes(data.imagePosition as string) &&
                            data?.imageHeight === 'adapt' &&
                            'h-full',
                          ['top', 'bottom'].includes(data.imagePosition as string) &&
                            data?.imageHeight === 'small' &&
                            'h-[280px] md:h-[420px]',
                          ['top', 'bottom'].includes(data.imagePosition as string) &&
                            data?.imageHeight === 'medium' &&
                            'h-[340px] md:h-[560px]',
                          ['top', 'bottom'].includes(data.imagePosition as string) &&
                            data?.imageHeight === 'large' &&
                            'h-[720px] md:h-[790px]'
                        )}
                      />
                    </Link>
                  </div>
                ))} */}

              {imgUrl &&
                (['top', 'bottom'].includes(data.imagePosition ?? '') ? (
                  <Link href={`/${data.imageUrl || '#'}`} className='w-full'>
                    <div
                      className={clsx(
                        'flex items-center justify-center overflow-hidden lg:mt-0',
                        data.imagePosition === 'top' || data.imagePosition === 'bottom'
                          ? 'w-full px-0 lg:w-full'
                          : 'px-4 lg:w-5/12'
                      )}
                      data-animation='true'
                    >
                      <img
                        src={imgUrl}
                        alt='mockup'
                        className={clsx(
                          'w-full object-cover',
                          !['top', 'bottom', 'left', 'right'].includes(
                            data.imagePosition as string
                          ) && 'max-h-[290px]',
                          ['top', 'bottom', 'left', 'right'].includes(
                            data.imagePosition as string
                          ) &&
                            data?.imageHeight === 'adapt' &&
                            'h-full',
                          ['top', 'bottom', 'left', 'right'].includes(
                            data.imagePosition as string
                          ) &&
                            data?.imageHeight === 'small' &&
                            'h-[280px] md:h-[420px]',
                          ['top', 'bottom', 'left', 'right'].includes(
                            data.imagePosition as string
                          ) &&
                            data?.imageHeight === 'medium' &&
                            'h-[340px] md:h-[560px]',
                          ['top', 'bottom', 'left', 'right'].includes(
                            data.imagePosition as string
                          ) &&
                            data?.imageHeight === 'large' &&
                            'h-[720px] md:h-[790px]'
                        )}
                      />
                    </div>
                  </Link>
                ) : (
                  <div
                    className={clsx(
                      'flex items-center justify-center overflow-hidden lg:mt-0',
                      data.imagePosition === 'top' || data.imagePosition === 'bottom'
                        ? 'w-full px-0 lg:w-full'
                        : 'px-4 lg:w-6/12'
                    )}
                    data-animation='true'
                  >
                    <Link href={`/${data.imageUrl || '#'}`}>
                      <img
                        src={imgUrl}
                        alt='mockup'
                        className={clsx(
                          'w-full object-cover',
                          !['top', 'bottom', 'left', 'right'].includes(
                            data.imagePosition as string
                          ) && 'max-h-[290px]',
                          ['top', 'bottom', 'left', 'right'].includes(
                            data.imagePosition as string
                          ) &&
                            data?.imageHeight === 'adapt' &&
                            'h-full',
                          ['top', 'bottom', 'left', 'right'].includes(
                            data.imagePosition as string
                          ) &&
                            data?.imageHeight === 'small' &&
                            'h-[280px] md:h-[420px]',
                          ['top', 'bottom', 'left', 'right'].includes(
                            data.imagePosition as string
                          ) &&
                            data?.imageHeight === 'medium' &&
                            'h-[340px] md:h-[560px]',
                          ['top', 'bottom', 'left', 'right'].includes(
                            data.imagePosition as string
                          ) &&
                            data?.imageHeight === 'large' &&
                            'h-[720px] md:h-[790px]'
                        )}
                      />
                    </Link>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      <style jsx>
        {`
          @media (min-width: 1024px) {
            .hero-padding {
              padding-top: ${data.padding?.top || 0}px;
              padding-bottom: ${data.padding?.bottom || 0}px;
              padding-left: ${data.padding?.left || 0}px;
              padding-right: ${data.padding?.right || 0}px;
            }
          }

          .overlay {
            background-color: ${data.overlay
              ? hexToRgb(data.overlay, Number(data.overlayPercentage || 100))
              : 'transparent'};
          }
          .background-color-default {
            background-color: ${data.colorScheme?.background || 'white'};
          }
          .background-color {
            background-color: ${data.background?.backgroundColor};
            --tw-bg-opacity: ${data.background?.backgroundOpacity};
          }
          .background-image {
            background-image: url(${data.background?.backgroundImage});
            background-repeat: no-repeat;
            background-size: ${data.background?.backgroundSize};
            background-position: ${data.background?.backgroundPosition};
            background-attachment: ${data.background?.backgroundAttachment === 'fixed'
              ? 'unset'
              : 'fixed'};
          }
          .hero-full-width {
            position: relative;
            left: 50%;
            right: 50%;
            margin-left: -50vw;
            margin-right: -50vw;
            width: 100vw;
          }
        `}
      </style>
    </>
  );
}
